import {fsVersion, functions,} from "../firestore";
import {addReducerParametersToError, CRASH_ERROR, sendError} from "../middleware/middleware-error-handler";
import {addToast} from "./duck-screen";

export const CREATE_RANKING = "CREATE_RANKING";
export const RESET_RANKING = "RESET_RANKING";
export const ADD_PLAYERS_TO_RANKING = "ADD_PLAYERS_TO_RANKING";
export const SET_IS_RANKING_LOADING = "SET_IS_RANKING_LOADING";
export const SET_ACTIVE_PLAYER_STATS = "SET_ACTIVE_PLAYER_STATS";
export const SET_RANKING_REACHED_END = "SET_RANKING_REACHED_END";

export const POINTS_RANKING_FIELDS = [
	"collectedPointsToday",
	"collectedPointsWeek",
	"collectedPointsAll",
	"collectedRiddlesToday",
	"collectedRiddlesWeek",
	"collectedRiddlesAll"
];

const rankingRef = {

};

let serverTimeStamp;
let localTimeStamp;

/* Wszystkie asynchroniczne funkcje */
export function fetchRanking(fieldName, isResuming = false){
	return async (dispatch, getState) => {
		const state = getState();

		if (state.rankingReducer.rankingReachedEnd[fieldName]) {
			return
		}

		dispatch(setIsRankingLoading(true, fieldName));

		if (!isResuming || rankingRef[fieldName] === undefined) {
			let query = fsVersion.collection("rankings")
				.where("isAnonymous", "==", false);

			const today = await getServerTimeStamp();

			if (fieldName === POINTS_RANKING_FIELDS[0] || fieldName === POINTS_RANKING_FIELDS[3]) {
				const lastCollectedDay = getLastCollectedDay(today);
				query = query.where("lastCollectedDay", "==", lastCollectedDay)
			} else if (fieldName === POINTS_RANKING_FIELDS[1] || fieldName === POINTS_RANKING_FIELDS[4]) {
				const lastCollectedWeek = getLastCollectedWeek(today);
				query = query.where("lastCollectedWeek", "==", lastCollectedWeek)
			}

			rankingRef[fieldName] = query.orderBy(fieldName, "desc").limit(10);
		}

		// return new Promise((resolve, reject) => {
		// 	if(serverTimeStamp === undefined){
		// 		return getServerTimeStampWithOffset()
		// 	} else {
		// 		return serverTimeStamp
		// 	}
		// })
		return rankingRef[fieldName]
			.get()
			.then(docsSnap => {
				const last = docsSnap.docs[docsSnap.docs.length - 1];

				if (last === undefined) {
					dispatch(setRankingReachedEnd(fieldName));
					throw Error("error_no_more_ranking_data")
				}

				if (docsSnap.docs.length < 10) {

					if(state.rankingReducer.ranking[fieldName] && state.rankingReducer.ranking[fieldName].length >= 10){
						dispatch(addToast("error_no_more_ranking_data"));
					}
					dispatch(setRankingReachedEnd(fieldName));

					console.log("zablokuj ładowanie")
				}

				rankingRef[fieldName] = rankingRef[fieldName].startAfter(last);

				// rankingRef[fieldName] = fsVersion.collection("rankings")
				// 	.where("isAnonymous", "==", false)
				// 	.orderBy(fieldName, "desc")
				// 	.startAfter(last)
				// 	.limit(10);

				return docsSnap.docs.map(doc => doc.data())
			})
			.then(ranking => {

				return ranking.map(player => {
					return {
						country: player.language,
						name: player.displayName,
						score: player[fieldName],
						img: player.avatar
					}
				})
			})
			.then(players => {
				if (isResuming) {
					dispatch(addPlayersToRanking(players, fieldName))
				} else {
					dispatch(createRanking(players, fieldName))
				}
			})
			.catch(error => {
				console.log(error);
				debugger;

				if (error.message === "error_no_more_ranking_data") {
					dispatch(addToast("error_no_more_ranking_data"));
					return
				}

				const inputParams = {
					fieldName,
					isResuming,
					uid: state.userReducer.uid
				};
				error.code = ""
				dispatch(sendError(error, CRASH_ERROR, 'error_fetching_ranking', JSON.stringify(inputParams)));
			})
			.then(() => {
				dispatch(setIsRankingLoading(false, fieldName))
			})
	}
}

function getServerTimeStamp(){

	if(serverTimeStamp){
		const offset = Date.now() - localTimeStamp;
		const originalServerDate = new Date(serverTimeStamp);
		const serverDateWithOffset = new Date(serverTimeStamp + offset);
		if(!isTheSameDay(originalServerDate, serverDateWithOffset)){
			serverTimeStamp = null
		}
		//TODO w else zapsz date z offsetem?
	}

	return serverTimeStamp ? new Date(serverTimeStamp) :
		functions.httpsCallable('getServerTimestamp')({})
			.then(result => {
				serverTimeStamp = result.data;
				localTimeStamp = Date.now();
				return new Date(serverTimeStamp)
			})
}

function isTheSameDay(lastCollectedDate, date){
	return (lastCollectedDate.getDay() === date.getDay() &&
		lastCollectedDate.getMonth() === date.getMonth() &&
		lastCollectedDate.getYear() === date.getYear())
}

function getLastCollectedDay(lastCollectedDate){
	const date = new Date(lastCollectedDate);
	date.setHours(0, 0, 0, 0);

	return date.toDateString()
}

function getLastCollectedWeek(lastCollectedDate){
	const date = new Date(lastCollectedDate);
	const diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1); // First day is the day of the month - the day of the week
	const firstDayOfWeek = new Date(date.setDate(diff));

	return firstDayOfWeek.toDateString()
}

export function resetRanking(){
	return {
		type: RESET_RANKING
	}
}
/**
 * Funkcja wywoływana przy starcie aplikacji
 * pobiera konfigurację gry z config/appConfig
 */

/* Wszystkie synchroniczne action creators */

/**
 * Funkcja tworzy nową listę z rankingiem
 * @param players - lista z użytkownikami
 * @param fieldName - nazwa pola z POINTS_RANKING_FIELDS
 */
export function createRanking(players, fieldName){
	return {
		type: CREATE_RANKING,
		payload: {
			players,
			fieldName
		}
	}
}

/**
 * Funkcja dodaje do aktualnej listy nowych użytkowników
 * @param players - lista z użytkownikami
 * @param fieldName - nazwa pola z POINTS_RANKING_FIELDS
 */
export function addPlayersToRanking(players, fieldName){
	return {
		type: ADD_PLAYERS_TO_RANKING,
		payload: {
			players,
			fieldName
		}
	}
}

/**
 * Funkcja włączana przed zapytaniem o listę rankingu i wyłączana po zwrotce
 * @param isLoading - boolean
 * @param fieldName - nazwa pola z POINTS_RANKING_FIELDS
 * @returns {{type: string, payload: {isLoading: *, fieldName: *}}}
 */
function setIsRankingLoading(isLoading, fieldName){
	return {
		type: SET_IS_RANKING_LOADING,
		payload: {
			isLoading,
			fieldName
		}
	}
}

function setRankingReachedEnd(fieldName){
	return {
		type: SET_RANKING_REACHED_END,
		payload: {
			fieldName
		}
	}
}

export function setActivePlayerStats(stats){
	return {
		type: SET_ACTIVE_PLAYER_STATS,
		payload: {
			stats,
		}
	}
}

export const defaultState = {
	ranking: {

	},
	isRankingLoading: {

	},
	rankingReachedEnd: {

	},
	activePlayerStats: {
		collectedPointsToday: 0,
		collectedPointsWeek: 0,
		collectedPointsAll: 0,
		collectedRiddlesToday: 0,
		collectedRiddlesWeek: 0,
		collectedRiddlesAll: 0,
	}
};


export default function(state = defaultState, action) {
	try{
		switch (action.type) {
			case CREATE_RANKING: {

				const newFieldRanking = action.payload.players;
				const newRanking = Object.assign({}, state.ranking, { [action.payload.fieldName] : newFieldRanking });

				return Object.assign({}, state, { ranking: newRanking });

			}
			case ADD_PLAYERS_TO_RANKING: {

				const currentFieldRanking = state.ranking[action.payload.fieldName] || [];
				const newFieldRanking = [...currentFieldRanking, ...action.payload.players];
				const newRanking = Object.assign({}, state.ranking, { [action.payload.fieldName] : newFieldRanking });

				return Object.assign({}, state, { ranking: newRanking });
			}
			case SET_IS_RANKING_LOADING: {

				const newIsRankingLoading = Object.assign({},
					state.isRankingLoading,
					{ [action.payload.fieldName]: action.payload.isLoading });

				return Object.assign({}, state, { isRankingLoading: newIsRankingLoading })
			}
			case SET_ACTIVE_PLAYER_STATS: {
				const playerStats = {};

				POINTS_RANKING_FIELDS.forEach(fieldName => {
					playerStats[fieldName] = action.payload.stats[fieldName]
				});

				return Object.assign({}, state, { activePlayerStats: playerStats });
			}
			case RESET_RANKING: {
				return Object.assign({}, state, { ranking: {}, rankingReachedEnd: {}, isRankingLoading: {} });
			}
			case SET_RANKING_REACHED_END: {
				const newRankingReached = Object.assign({},
					state.rankingReachedEnd,
					{ [action.payload.fieldName]: true });

				return Object.assign({}, state, { rankingReachedEnd: newRankingReached })
			}
			default:
				return state;
		}
	} catch (error){
		addReducerParametersToError(error, "error_ranking_reducer", action, state);
		throw error
	}
}
